import axios from 'axios';
import { EDIT_FORM_URL, GET_FORMS_URL, get_request_config } from '@/utils/system_constants/constant.js';
import { extract_items } from '@/utils/api_response_helpers';

export async function fetch_form(form_id) {
  const response = await axios.get(GET_FORMS_URL, get_request_config());
  const forms = extract_items(response);
  return (Array.isArray(forms) ? forms : []).find(
    (form) => String(form?.id) === String(form_id),
  ) || {};
}

export async function update_form_instructions(form_id, form_instructions) {
  const response = await axios.post(
    EDIT_FORM_URL,
    { form_id: Number(form_id), form_instructions },
    get_request_config(),
  );
  return response?.data;
}
